module.exports = __webpack_public_path__ + "public/img/banner-3.5fca2612.jpg";